import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserRightsService } from '@schenck/rotec-components';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserRightsActions } from 'src/utils/enums/user-rights.enum';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly userRightsService = inject(UserRightsService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.userRightsService.hasActionRights$(UserRightsActions.readTemplate).pipe(
      map((hasViewRight) => {
        return hasViewRight;
      })
    );
  }
}
